module.exports = __webpack_public_path__ + "static/media/antolini.7b6255e2.jpg";